/**
 * Singleton that handles all things surrounding SearchDrop Animation
 */
//var SearchDropAnimator = (function() {
define(['jquery', 'c21/WordCollapsasaurus'], function ($, WordCollapsasaurus) {
   "use strict";

   var m_jDropdownContent,
      m_jDropdownSearchBox,
      m_jDropdownResults,
      m_jDropdownSearchContent,
      m_iSpeed = 150,
      m_jSearchBox,
      m_bSearchDropVisible, m_bInitialized, m_iSlideSpeedMilliseconds;

   function showDropdown() {
      lazyInit();
      //m_jDropdownSearchBox.css({ height: 60 });
      //m_jDropdownResults.css({ top: 60 });
      m_jDropdownSearchContent.show();
      m_jDropdownContent.slideDown(m_iSpeed, 'easeOutCubic', function() {
         setTimeout(function() {
            // hasLayout fix for IE7
            m_jDropdownContent.css({
               zoom: 1
            });
         }, 1);
      });
      m_jSearchBox.addClass('expanded');
      activateWordCollapsasaurus();
   }

   function hideDropdown() {
      // Clear the enter key stroke event
      if (window.fts) {
         window.fts.enterKey = "";
         window.fts.singleLocationID = "";
         window.fts.suggestType = "";
      }

      lazyInit();
      m_jDropdownSearchContent.hide();
      m_jDropdownContent.hide();
      //m_jDropdownSearchBox.css({ height: 66 });
      //m_jDropdownResults.css({ top: 66 });
      m_jSearchBox.removeClass('expanded');
   }

   function activateWordCollapsasaurus() {
      $('.suggestCollapse').each(function() {
         new WordCollapsasaurus($(this));
      });
   }

   /**
    * Show the content inside of the search box
    */
   function showDropContents() {
      showDropdown();
      m_bSearchDropVisible = true;
      activateWordCollapsasaurus();
   }

   /**
    * Hide the content inside of the search box
    */
   function hideDropContents() {
      hideDropdown();
      m_bSearchDropVisible = false;
   }

   /**
    * Add the onblur event that hides the search box
    */
   function addOnBlurEvent() {
      $(document).click(function(e) {
         var jClicked = $(e.target),
            bIsChildOfSearchBox = (jClicked.parents().filter(
               m_jSearchBox).length > 0);

         if ((e.target === m_jSearchBox.get(0)) || bIsChildOfSearchBox) {
            e.stopPropagation();
            return;
         }

         hideDropdown();
      });
   }

   /**
    * A lazy initialization function, only called when needed
    */
   function lazyInit() {
      // Do not initialize more than once
      if (m_bInitialized)
         return;

      m_bInitialized = true;
      m_jDropdownContent = $("#dropdownContent");
      m_jDropdownSearchBox = $("#dropdownSearchBox");
      m_jDropdownResults = $("#dropdownResults");
      m_jDropdownSearchContent = $("#dropdownSearchContent");

      m_jSearchBox = $('#dropdown');
      m_bSearchDropVisible = false;
      m_iSlideSpeedMilliseconds = 200;
      addOnBlurEvent();
   }

   return {
      hideSearchDrop : hideDropContents,
      showSearchDrop : showDropContents,
      showDropContents : showDropdown,
      hideDropContents : hideDropdown
   };
});
